// Case study "Our Solution" alternative designs (template-parts/components/case-studies/solution-tabs.php).

// Horizontal tab strips on small screens: keep the chosen tab visible and show a fade while
// more tabs are hidden to the right. Only scrolls the strip, never the page.
const revealInStrip = (strip, item) => {
    if (!strip || !item || strip.scrollWidth <= strip.clientWidth) return;
    const left = item.offsetLeft - strip.offsetLeft - 16;
    strip.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
};

const watchStrip = (strip) => {
    const update = () => strip.classList.toggle('has-more', strip.scrollLeft + strip.clientWidth < strip.scrollWidth - 4);
    strip.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
};
document.addEventListener('DOMContentLoaded', () => {
    // Switcher (F): accessible tabs, arrow keys move between tabs
    document.querySelectorAll('[data-cs-solution-switcher]').forEach((root) => {
        const tabs = [...root.querySelectorAll('[role="tab"]')];

        const strip = root.querySelector('.cs-solution-switcher__track');
        if (strip) watchStrip(strip);

        const select = (tab) => {
            revealInStrip(strip, tab);
            tabs.forEach((t) => {
                const on = t === tab;
                t.setAttribute('aria-selected', on ? 'true' : 'false');
                t.tabIndex = on ? 0 : -1;
                const panel = root.querySelector('#' + t.getAttribute('aria-controls'));
                if (panel) panel.hidden = !on;
            });
        };

        tabs.forEach((tab, i) => {
            tab.addEventListener('click', () => select(tab));
            tab.addEventListener('keydown', (e) => {
                const step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
                if (!step) return;
                e.preventDefault();
                const next = tabs[(i + step + tabs.length) % tabs.length];
                select(next);
                next.focus();
            });
        });
    });

    // Index (H): highlight the menu link of the card in view
    document.querySelectorAll('[data-cs-solution-index]').forEach((root) => {
        const nav = root.querySelector('.cs-solution-index__nav');
        if (nav) watchStrip(nav);
        const links = [...root.querySelectorAll('.cs-solution-index__nav a')];
        const cards = links.map((a) => root.querySelector(a.getAttribute('href')));
        if (!('IntersectionObserver' in window) || cards.some((c) => !c)) return;

        const io = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                const i = cards.indexOf(entry.target);
                links.forEach((a, j) => a.classList.toggle('is-active', i === j));
                revealInStrip(nav, links[i]);
            });
        }, { rootMargin: '-40% 0px -55% 0px' });

        cards.forEach((card) => io.observe(card));
    });

    // Original Tabs design: same strip behaviour for its tab list
    document.querySelectorAll('.solution-tabs .tabs-nav').forEach((strip) => {
        watchStrip(strip);
        strip.querySelectorAll('.tab-item').forEach((item) => {
            item.addEventListener('click', () => revealInStrip(strip, item));
        });
    });
});
